import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import { Modal, Form, InputGroup } from 'react-bootstrap';
import { Button, ButtonGroup } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import { FaExclamationCircle } from 'react-icons/fa';
import { FaArrowUpShortWide, FaArrowDownShortWide } from 'react-icons/fa6';
import { AuthContext } from '../../../../../context/AuthContext';
import AddTrip from '../../../Meal/component/Booking/components/AddTrip';
import EditBooking from '../../../Booking/component/Pending/EditBooking';
import ConfirmationModal from '../../ConfirmationModal';
import { BookingContext } from '../../../../../context/BookingContext';
import { PermissionContext } from '../../../../../context/PermissionContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const DataReactTable = () => {
  const [TripData, setTripData] = useState([]);
  const { paxs, setPaxs } = useContext(BookingContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext); 
  const { userid, apiGlobal } = useContext(AuthContext);
  const [showAddModal, setShowAddModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showdeleteModal, setShowDeleteModal] = useState(false);
  const [tripID, setTripID] = useState();
  const [paxDetailsHandler, setPaxDetailsHandler] = useState([]);
  const [paxData, setPaxData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({}); // State to track which row is expanded
  const { permissionsAccess } = useContext(PermissionContext);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Search filter states
  const [searchTripName, setSearchTripName] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const fetchOnGoingTripData = async () => {
    try {
      const url = await fetch(`${apiGlobal}/trip_ongoing_data.php`);
      const data = await url.json();
      if (data.status && data.message === 'Success') {
        setTripData(data.data);
      } else {
        setTripData([]);
        console.error(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchOnGoingTripData();
  }, [apiGlobal, userid, refresh, sideBarRefresh?.adminTripRefresh]);

  useEffect(() => {
    // Reset the current page when data changes
    setCurrentPage(1);
  }, [TripData]);

  // Filter logic
  const filteredData = TripData.filter((trip) => {
    // Check trip name filter
    const matchTripName = trip.name.toLowerCase().includes(searchTripName.toLowerCase());

    // Check start date filter
    const matchStartDate = trip.start_date
      .toLowerCase()
      .includes(searchStartDate.toLowerCase());

    // Check end date filter
    const matchEndDate = trip.end_date
      .toLowerCase()
      .includes(searchEndDate.toLowerCase());

    return matchTripName && matchStartDate && matchEndDate;
  });

  // Pagination Logic - Slice filtered data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // handle trip Add
  const handletripAdd = async (values) => {
    const utcStartDate = values.startDate;
    const utcEndDate = values.endDate;

       // Convert to IST
       const startDate = new Date(utcStartDate);
       const endDate = new Date(utcEndDate);

       if (startDate >= endDate) {
        toast.error('Start date must be earlier than end date');
        return; // Or any other action you'd like to perform
      }
   
       // IST offset is +5:30
      const istOffset = 5.5 * 60 * 60 * 1000;
      const startDateIST = new Date(startDate.getTime() + istOffset);
      const endDateIST = new Date(endDate.getTime() + istOffset); 
      
      // Format the dates (DD-MM-YYYY)
      const formatDates = date => `${date.getFullYear()}-${String(date.getMonth() + 1)
       .padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
   
   
   const formattedStartDate = formatDates(startDateIST);
   const formattedEndDate = formatDates(endDateIST);

   const formattedValues = {
    pax_details: paxs,
};

const formattedPaxDetails = JSON.stringify(formattedValues);


  //  console.log(values.selectAgent.value);

    const formData = new FormData();
    formData.append('agent_id', values.selectAgent.value);
    formData.append('name', values.tripname);
    formData.append('user_id', userid);
    formData.append('start_date', formattedStartDate);
    formData.append('end_date', formattedEndDate);
    formData.append('trip_type', values.triptype);
    formData.append('pax_details', formattedPaxDetails);

     formData.append('user_id', userid);
      formData.append('type', 0);
    
      
  try {
    // Send POST request with form data
    const response = await fetch(`${apiGlobal}/trip_add.php`, {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      // },
      body: formData, 
    });
  
    if (response.ok) {
      const data = await response.json(); // Parsing the response JSON
      // console.log(data);
      if (data.status && data.message === 'Success') {
        toast.success('Trip added successfully...');
        setRefresh(prev => !prev);
        setShowAddModal(false);
        setPaxs([]);
      }
    } else {
      // Handle non-200 responses
      console.error('Error:', response.statusText);
      toast.error('Something went wrong while adding paxs');
    }
  } catch (error) {
    // Catch any network or other errors
    console.error('Error during fetch:', error);
  }
  };



  const handleEditTrip = async (value) => {
    // console.log(value);
    const utcStartDate = value.startDates;
      const utcEndDate = value.endDate;

      const startDate = new Date(utcStartDate);
      const endDate = new Date(utcEndDate);
   
      if (startDate >= endDate) {
        toast.error('Start date must be earlier than end date');
        return; // Or any other action you'd like to perform
      }

      const istOffset = 5.5 * 60 * 60 * 1000;
      const startDateIST = new Date(startDate.getTime() + istOffset);
     const endDateIST = new Date(endDate.getTime() + istOffset);  

     // Format the dates (DD-MM-YYYY)
     const formatDates = dates => `${dates.getFullYear()}-${String(dates.getMonth() + 1)
      .padStart(2, '0')}-${String(dates.getDate()).padStart(2, '0')}`;

      const formattedStartDate = formatDates(startDateIST);
      const formattedEndDate = formatDates(endDateIST);

      const formattedValues = {
        pax_details: paxDetailsHandler,
    };
    
    const formattedPaxDetails = JSON.stringify(formattedValues);
       const formData = new FormData();
       formData.append('trip_id', tripID);
       formData.append('name', value.tripName);
       formData.append('start_date', formattedStartDate);
       formData.append('end_date', formattedEndDate);
       formData.append('trip_type', value.triptype);
      formData.append('pax_details', formattedPaxDetails);

      formData.append('user_id', userid);
      formData.append('type', 0);

    //    formData.forEach((values, key) => {
    //     console.log(`${key}: ${JSON.stringify(values)}`);
    // });

    
        

       try {
           const url = await fetch(`${apiGlobal}/trip_edit.php`, {
            method: 'POST',
            body: formData,
           });
           const response = await url.json();
           if (response.status && response.message === 'Trip and Pax details updated successfully.') {
             toast.success('Trip Edit Successfull');
             setShowEditModal(false);
             setRefresh(prev => !prev);
           } else {
            toast.error('Error in updating trip details');
            setShowEditModal(true);
           }
          //  console.log(response);
       } catch (error) {
         console.log(error);
       }
   };
  const editModalHandler = (bookingid) => {
     // Check if the row for the current tripId is expanded
  if (expandedRows[bookingid]) {
    // If it's expanded, toggle it to unexpanded (set it to false)
    setExpandedRows(prev => ({
      ...prev,
      [bookingid]: false,
    }));
  }
    setTripID(bookingid);
    setShowEditModal(true);
   };

   const handlePaxDetailsToggle = async (tripId) => {
    // First, toggle the expanded state for this row
    setExpandedRows((prev) => {
      const newState = { ...prev };
      // If we're already expanded, just collapse
      if (newState[tripId]) {
        newState[tripId] = false;
        return newState;
      }
      
      // Otherwise, collapse all other rows and expand this one
      Object.keys(newState).forEach((key) => {
        newState[key] = false;
      });
      newState[tripId] = true;
      return newState;
    });
  
    // If we're expanding this row, fetch the data
    if (!expandedRows[tripId]) {
      // Clear old data first
      setPaxData([]);
      
      try {
        const url = await fetch(`${apiGlobal}/trip_data_fetch.php?id=${tripId}`);
        const data = await url.json();
        if (data?.status && data?.message === 'Success') {
          setPaxData(data?.pax_details);
        } else {
          toast.error(data?.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Toggle Pax Details row
  // const handlePaxDetailsToggle = async (tripId) => {
  //   try {
  //     const url = await fetch(`${apiGlobal}/trip_data_fetch.php?id=${tripId}`);
  //       const data = await url.json();
  //       if (data?.status && data?.message === 'Success') {
  //         setPaxData(data?.pax_details);
  //       } else {
  //         toast.error(data?.message);
  //       }
  //   } catch (error) {
  //      console.log(error);
  //   }
        

  //   setExpandedRows(prev => ({
  //     ...prev,
  //     [tripId]: !prev[tripId], // Toggle the visibility of Pax Details for this row
  //   }));
  // };

    // // Re-fetch Pax details when `refresh` state changes
    // useEffect(() => {
    //   if (expandedRows[trip?.id]) {
    //     handlePaxDetailsToggle(trip?.id);
    //   }
    // }, [refresh]); // Dependency on `refresh` to trigger re-fetch

  const showDeleteModal = (tripid) => {
    setShowDeleteModal(true);
    setTripID(tripid);
  };

  const handleConfirmDelete = async () => {
    try {
      const url = await fetch(`${apiGlobal}/trip_delete.php?id=${tripID}&type=0&user_id=${userid}`);
      const response = await url.json();
       if (response.status && response.message === 'record deleted successfully') {
        toast.success('Trip Delete Successfully');
        setShowDeleteModal(false);
        setRefresh(prev => !prev);
       } else {
        toast.error(response.message);
       }
    } catch (error) {
      console.log(error);
    }
  };

  const [sortOrder, setSortOrder] = useState('asc');
  const [sortColumn, setSortColumn] = useState('name'); // This will track the column being sorted
   
 
  // Sorting function
  const handleSort = (column) => {
    const newSortOrder = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';

    const sortedData = [...TripData].sort((a, b) => {
      if (!a[column] || !b[column]) return 0; // Handle undefined values

      if (typeof a[column] === 'string' && typeof b[column] === 'string') {
        return newSortOrder === 'asc'
          ? a[column].localeCompare(b[column])
          : b[column].localeCompare(a[column]);
          // eslint-disable-next-line
      } else {
        return newSortOrder === 'asc' ? a[column] - b[column] : b[column] - a[column];
      }
    });

    setTripData(sortedData);
    setSortColumn(column);
    setSortOrder(newSortOrder);
  };
  

  // use Effect to add keyframes for the pulse animation
  useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);



  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px', // Add gap between the input fields
          alignItems: 'center', // Vertically align input fields and button
          flexWrap: 'wrap', // Make sure the filters stay in a single line
        }}
      >
        <h5
          className="mb-2"
          style={{
            color: '#495057',
            alignSelf: 'center',
            marginRight: '20px',
            fontWeight: '600',
          }}
        >
          Filter Trips
        </h5>

        <InputGroup className="mb-2" style={{ maxWidth: '200px' }}>
          <Form.Control
            type="text"
            placeholder="Search by Trip Name"
            value={searchTripName}
            onChange={e => setSearchTripName(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchStartDate}
            onChange={e => setSearchStartDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="End Date"
            value={searchEndDate}
            onChange={e => setSearchEndDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchTripName('');
            setSearchStartDate('');
            setSearchEndDate('');
          }}
        >
          Clear Filters
        </Button>
        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '2px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setRefresh(prev => !prev);
          }}
        >
          Refresh
        </Button>
        {permissionsAccess?.[6]?.master_id === '7'
              && permissionsAccess?.[6]?.create === 1 && (
                <Button
                  variant="outline-primary"
                  style={{
            borderRadius: '25px',
            padding: '8px 16px',
            alignSelf: 'center',
          }}
                  className="mt-3"
                  onClick={() => setShowAddModal(true)}
                >
                  Add Trip
                </Button>
              )}
        
      </div>

      <Table
        responsive
        style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead className="bg-success" style={{ color: 'white', textAlign: 'center' }}>
          <tr>
            <th>#</th>
            <th>Agent Name</th>
            <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
              Trip Name {sortColumn === 'name' 
              && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownShortWide />)}
            </th>
            <th onClick={() => handleSort('trip_uin')} style={{ cursor: 'pointer' }}>
              Trip ID {sortColumn === 'trip_uin' 
              && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownShortWide />)}
            </th>
            <th>Date - (From/To)</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{
                textAlign: 'center',
    padding: '50px',
    backgroundColor: '#f8d7da',
    borderRadius: '8px',
    marginTop: '20px',
                color: '#721c24',
    fontSize: '16px',
              }}
                >
                  <div
                    style={{
fontSize: '48px',
marginBottom: '20px',
color: '#e63946',
animation: 'pulse 1.5s infinite ease-in-out',
display: 'inline-block',
}}
                  >
                    <FaExclamationCircle />
                  </div>
                  <p>No ongoing trip available</p>
                </div>
              </td>
              
            </tr>
          ) : (
            currentItems.map((trip, index) => (
              <React.Fragment key={trip.id}>
                <tr
                  style={{
                    backgroundColor: '#ffffff',
                    textAlign: 'center',
                    height: '76px',
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{trip?.agent_details?.name}</td>

                  <td>{trip?.name}</td>
                  <td>{trip?.trip_uin}</td>
                  <td>
                    {formatDate(trip?.start_date)} / {formatDate(trip?.end_date)}
                  </td>
                  <td>
                    Live{' '}
                    <span
                      style={{
                        display: 'inline-block',
                        animation: 'spin 1s linear infinite',
                      }}
                    >
                      🟢
                    </span>
                  </td>
                  <td>
                    <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
                      <Button 
                        variant="outline-primary" 
                        title="Pax Details" 
                        onClick={() => handlePaxDetailsToggle(trip?.id)}
                      >
                        <span className="lnr lnr-users" />
                      </Button>
                      {permissionsAccess?.[6]?.master_id === '7'
              && permissionsAccess?.[6]?.edit === 1 && (
              <Button 
                variant="outline-warning" 
                title="Edit" 
                onClick={() => editModalHandler(trip?.id)}
              >
                <span className="lnr lnr-pencil" />
                        
              </Button>
              )}
                      {permissionsAccess?.[6]?.master_id === '7'
              && permissionsAccess?.[6]?.delete === 1 && (
              <Button variant="outline-danger" title="Delete" onClick={() => showDeleteModal(trip?.id)}>
                <span className="lnr lnr-trash" />
              </Button>
              )}
                      
                      
                    </ButtonGroup>
                  </td>
                </tr>

                {/* Pax Details Table - only visible if expanded */}
                {expandedRows[trip?.id] && (
                  <tr>
                    <td colSpan="8" style={{ padding: '20px' }}>
                      <Table
                        responsive
                        style={{
                      backgroundColor: '#f9f9f9',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    }}
                      >
                        <thead className="bg-info" style={{ color: 'white', textAlign: 'center' }}>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Age Group</th>
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: 'center' }}>
                          {/* Replace this with actual Pax details data */}
                          {paxData?.map((pax, indexx) => (
                            <tr key={pax?.id}>
                              <td>{indexx + 1}</td>
                              <td>{pax?.pax_name || 'NA'}</td>
                              <td>{pax?.email_id || 'NA'}</td>
                              {/* <td>{pax.flag}</td> */}
                              <td>{pax?.mobile_no || 'NA'}</td>
                              <td>{pax?.age_group === '1' ? 'Adult' : 'Child'}</td>
                            </tr>
                            ))}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      {filteredData.length > 0 && (
        <div
          style={{
            bottom: '20px',
            right: '20px',
            zIndex: 999,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>
      )}

      {/* Modal for Add Trip */}
      <Modal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        centered
        size="xl"
        backdrop="static" // Prevent clicking outside the modal to close it
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Trip</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddTrip onSubmit={handletripAdd} />
        </Modal.Body>
      </Modal>
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Trip</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditBooking 
            onSubmit={handleEditTrip} 
            bookingID={tripID}
            setPaxDetailsHandler={setPaxDetailsHandler}
            paxDetailsHandler={paxDetailsHandler}
          /> 
          {/* <AddTrip onSubmit={handletripAdd} /> */}
        </Modal.Body>
      </Modal>
      <ConfirmationModal 
        show={showdeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleDelete={handleConfirmDelete}
        header="Confirm Delete"
        message="Are you sure you want to Delete this trip?"
        buttonType="danger"
        buttonText="Delete"
      />
    </div>
  );
};

export default DataReactTable;
